const defaultFormattingOptions: Intl.NumberFormatOptions = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
}

export const splitFormattedNumber = (value: string | number) => {
    const str =
        typeof value === 'number'
            ? value.toLocaleString(undefined, defaultFormattingOptions)
            : String(value)
    const [integerPart, decimalPart] = str.split('.')
    return { integerPart, decimalPart }
}
